module.exports = __webpack_public_path__ + "static/meal-finder-853582c87750d32592455be343bb84b0.jpg";